<template>
  <div class="purchase-approval-container">
    <div class="section-header">
      <div class="header-left">
        <h2 class="title">采购申请审批</h2>
        <span class="sub-title">企业部门采购物资申请流转进度与在线协同审批</span>
      </div>
    </div>

    <!-- 顶部状态胶囊导航 -->
    <div class="tab-capsule-wrapper">
      <div
        v-for="(item, index) in tagList"
        :key="'tag' + index"
        class="tab-capsule"
        :class="{ active: form_head_uuid === item.form_head_uuid }"
        @click="changeIndex(item.form_head_uuid)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>

    <!-- 审批内容列表 -->
    <template v-if="show">
      <ApprovalList
        v-if="
          [
            '403e15205bc248f48d8a3626571c4e56',
            '91e9bb4eac0a48b38e8327cc9c6c23de',
            '33d336e546644de7afb25e1989757d93'
          ].includes(form_head_uuid)
        "
        form_id="436ae44d1c60475a9b4009ca40edc11e"
        :form_head_uuid="form_head_uuid"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ApprovalList from '@/components/ApprovalList.vue';

export default {
  name: "Purchase",
  components: {
    ApprovalList,
  },
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      tagList: [
        { name: "审核中", form_head_uuid: "403e15205bc248f48d8a3626571c4e56" },
        { name: "审核成功", form_head_uuid: "91e9bb4eac0a48b38e8327cc9c6c23de" },
        { name: "审核驳回", form_head_uuid: "33d336e546644de7afb25e1989757d93" },
      ],
      form_head_uuid: "403e15205bc248f48d8a3626571c4e56",
      page: 1,
      total: 0,
      limit: 20,
      show: true,
    };
  },
  methods: {
    changeIndex (form_head_uuid) {
      if (this.form_head_uuid === form_head_uuid) return;
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      if (['403e15205bc248f48d8a3626571c4e56', '91e9bb4eac0a48b38e8327cc9c6c23de', '33d336e546644de7afb25e1989757d93'].includes(form_head_uuid)) {
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    navTo (route) {
      this.$router.push(route);
      this.$store.commit('setData', {
        form_head_uuid: this.form_head_uuid
      });
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.purchase-approval-container {
  width: 100%;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid #f1f5f9;

    .header-left {
      display: flex;
      align-items: baseline;
      gap: 12px;

      .title {
        font-size: 16px;
        font-weight: 700;
        color: #0f172a;
        margin: 0;
      }

      .sub-title {
        font-size: 13px;
        color: #64748b;
      }
    }
  }

  .tab-capsule-wrapper {
    display: inline-flex;
    background: #f1f5f9;
    padding: 3px;
    border-radius: 8px;
    margin-bottom: 20px;

    .tab-capsule {
      padding: 6px 18px;
      font-size: 13px;
      font-weight: 500;
      color: #64748b;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        color: @brandPrimary;
      }

      &.active {
        background: #ffffff;
        color: @brandPrimary;
        font-weight: 700;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/Purchase.vue